<template>
  <div class="combcheck">
    <div class="comb-wrap" v-for="(item, i) in content.accData" :key="i">
      <div class="comb-hd">{{ item.typeName }}</div>
      <ul class="comb-bd">
        <li
          class="comb-item"
          v-for="(tititem, j) in item.child"
          :key="j"
          :class="{ active: id == tititem.ae }"
        >
          <div>
            <el-checkbox
              v-model="tititem.selected"
              :disabled="tititem.disabled"
            ></el-checkbox>
            <span
              class="comb-item-label"
              @click="optshow(tititem.ae)"
              :class="{ active: id == tititem.ae }"
            >
              {{ tititem.name }}
            </span>
          </div>
          <transition name="el-zoom-in-center">
            <div class="comb-info" v-if="id == tititem.ae">
              <div class="comb-product">
                <div class="comb-img">
                  <img src="" alt="" style="width: 52px" />
                </div>
                <div class="comb-title">
                  <div class="name">{{ tititem.name }}</div>
                  <div class="p-ellipsis">
                    <span class="p-detail-label">订货号：</span>
                    {{ tititem.order }}
                  </div>
                  <div class="p-ellipsis">
                    <span class="priced">￥{{ tititem.price }}</span>
                    <span class="price-before">￥{{ tititem.price }}</span>
                  </div>
                </div>
                <div class="comb-title"></div>
              </div>
              <div class="prop">
                <div
                  class="props-wrap"
                  v-for="(titdata, k) in tititem.props"
                  :key="k"
                >
                  <!-- v-show="titdata.layShow==1" -->
                  <div class="prop-hd">
                    {{ titdata.propName }}
                    {{ tititem.propId }}
                  </div>
                  <ul class="prop-bd">
                    <li
                      class="prop-item"
                      v-for="(optdata, z) in titdata.child"
                      :key="z"
                      :class="newcolor(optdata.select)"
                      @click="newoptid(tititem, titdata.propId, optdata.optId)"
                    >
                      {{ optdata.optName }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </transition>
        </li>
      </ul>
    </div>
    <div class="content" v-if="content.accData.length == 0">暂无附件</div>
  </div>
</template>

<script>
import { mapState } from "vuex";

import { getsperdata } from "../util/getData.js";

export default {
  data() {
    return {
      checkedarr: [],
      id: 0,
      data: {
        content: {},
        data: {
          spedata: {}, //本体数据
          accdata: {}, //附件数据

          defaultSelected: [], //默认选中
          ShortName: "", //名称
          acckey: [],
        },
      },
      accoptstr: [] /* 层级id和选项id */,
    };
  },

  computed: {
    ...mapState(["sid", "shortname", "defaultselect"]),
    // content(){
    //     return this.$store.state.content
    // },
    // spedata(){
    //     return this.$store.state.spedata
    // },
    // accdata(){
    //     return this.$store.state.accdata
    // },
  },

  watch: {
    sid() {
      this.alldata();
    },
    content(newVal) {
      this.contdata(newVal);
    },
  },

  created() {
    this.contdata(this.content);
    this.alldata();
    console.log(123);
  },

  methods: {
    contdata(data) {
      // console.log(data.accData);
      this.accoptstr = [];
      for (let i = 0; i < data.accData.length; i++) {
        for (let j = 0; j < data.accData[i].child.length; j++) {
          for (let k = 0; k < data.accData[i].child[j].props.length; k++) {
            for (
              let z = 0;
              z < data.accData[i].child[j].props[k].child.length;
              z++
            ) {
              if (data.accData[i].child[j].props[k].child[z].select) {
                let obj = {
                  ae: "",
                  ck: 0,
                  tid: "",
                  pid: "",
                };
                if (data.accData[i].child[j].selected) {
                  obj.ck = 1;
                }
                obj.ae = data.accData[i].child[j].ae;
                obj.tid = data.accData[i].child[j].props[k].propId;
                obj.pid = data.accData[i].child[j].props[k].child[z].optId;

                this.accoptstr.push(obj);
              }
            }
          }
        }
      }
      console.log(this.accoptstr);
    },

    alldata() {
      console.log();
      this.data.data.spedata = this.spedata;
      this.data.data.accdata = this.accdata;
      this.data.data.defaultSelected = this.defaultselect;
      this.data.data.ShortName = this.shortname;
      // this.data.content=getsperdata(this.data.data)
      // console.log(this.data.content);
    },
    /* 显示隐藏附件详情数据 */
    optshow(aid) {
      if (aid != this.id) {
        this.id = aid;
      } else {
        this.id = 0;
      }
    },
    /*  */
    newcolor(id) {
      if (id) {
        return "activea";
      }
    },

    newoptid(item, tid, pid) {
      for (let i = 0; i < this.accoptstr.length; i++) {
        if (this.accoptstr[i].ae == item.ae && this.accoptstr[i].tid == tid) {
          this.accoptstr[i].pid = pid;
        }
      }
      this.data.content = getsperdata(this.data.data);
      console.log(this.data.content);
    },
  },
};
</script>

<style scoped lang="less">
@import "../assets/less/annex";
</style>